"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }

var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);


/* The caller's open requests (GetOpenRequests), newest first. Replaced by
 * each load; a request marked handled here leaves at once. */




const initialState = { list: [] }

 function openRequestsReducer (
  state = initialState,
  action,
) {
  switch (action.type) {
    case _actionCreators2.default.getOpenRequestsActions.SUCCESS.type: {
      // SAFETY: GetOpenRequests' response.
      const list = _optionalChain([(action.payload ), 'optionalAccess', _ => _.Requests])
      return { list: _nullishCoalesce(list, () => ( [])) }
    }

    case _actionCreators2.default.markRequestHandledActions.SUCCESS.type: {
      // SAFETY: markRequestHandled puts the request's key in the meta.
      const todoKey = _optionalChain([action, 'access', _2 => _2.meta, 'optionalAccess', _3 => _3.TodoKey]) 
      if (!todoKey || !state.list.some(r => r.TodoKey === todoKey)) return state
      return { list: state.list.filter(r => r.TodoKey !== todoKey) }
    }

    case _actionCreators2.default.logoutAction.type:
      return state === initialState ? state : initialState
  }
  return state
} exports.default = openRequestsReducer;
